import { CustomResponseInterface } from "../../interfaces/ActionReducer/GetMethod/GetResponse";
import { GetRequestInterface } from "../../interfaces/ActionReducer/GetMethod/GetRequest";
import { SelectValue } from "interfaces/Select/Value";

export const GET_LANGUAGE_OPTIONS = "GET_LANGUAGE_OPTIONS";
export const RECEIVED_LANGUAGE_OPTIONS = "RECEIVED_LANGUAGE_OPTIONS";
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";

export interface LanguageInterface {
    id: number;
    name: string;
    display_name: string;
    data: Object;
    is_default: boolean;
}

export type LanguageOptionsInterface = CustomResponseInterface<LanguageInterface[]>;

export interface GetLanguageOptions {
    type: typeof GET_LANGUAGE_OPTIONS;
    payload: { params: GetRequestInterface };
}

export interface ReceivedLanguageOptions {
    type: typeof RECEIVED_LANGUAGE_OPTIONS;
    payload: { languages: LanguageOptionsInterface };
}

export interface SetCurrentLanguage {
    type: typeof SET_CURRENT_LANGUAGE;
    payload: { currentLanguage: SelectValue };
}

export interface MultiLingualStateInterface {
    languageOptions: LanguageOptionsInterface;
    isLanguageOptionsReceived: boolean;
    currentLanguage: SelectValue;
}

export type MultiLingualState = MultiLingualStateInterface;

export type MultiLingualTypes = GetLanguageOptions | ReceivedLanguageOptions | SetCurrentLanguage;
